module.exports = __webpack_public_path__ + "img/icon1.cfa2a4e7.png";